module.exports = __webpack_public_path__ + "static/media/wabg.8a055527.png";